<!--
 * @Author: Haoxiwei 1078734933@qq.com
 * @Date: 2024-02-23 13:54:22
 * @LastEditors: Haoxiwei 1078734933@qq.com
 * @LastEditTime: 2024-03-01 17:12:52
 * @FilePath: /wemeet-iam/Users/hvv/weMeetSpace/wemeet-poster/src/views/multilingual/components/MainPageBtn.vue
 * @Description: 
 * Copyright (c) 2024 by WeMeet, All Rights Reserved. 
-->
<template>
  <div :class="customClass" class="bg-white mt-10 br-10 p-10 border-box d-flex a-center j-sb">
    <div class="d-flex  br-27 border-box fz-13 text-wrap text-center" style="align-items:center;justify-content:center;min-height: 27px;border: 1px solid #00C4C9;width: 48%; color:#fff;background:#00C4C9;padding-top:5px;padding-bottom: 5px;" @click="downLoadQrcode">
      <div class="text-wrap w-100">{{leftBtnWord}}</div>
    </div>
    <div class="d-flex  br-27 border-box fz-13 cor-00C4C9 text-center" style="align-items:center;justify-content:center;min-height: 27px;border: 1px solid #00C4C9;width: 48%;padding-top:5px;padding-bottom: 5px;" @click="downLoadvcf">
      <div class="text-wrap w-100">{{rightBtnWord}}</div>
    </div>

    <van-overlay :show="show">
      <div class="dialogContainer">
        <div class="close" @click.stop="show =false">
          <img src="../../../assets/closeIcon.png" style="width:15px;height:15px" alt="">
        </div>
        <div class="name text-ellipsis-1">{{userBaseInfo.name}}</div>
        <div class="position text-center text-ellipsis-2">{{userBaseInfo.company || userBaseInfo.companyName}}</div>
        <img :src="qrCodeUrl" alt="" class="qrCode">
        <div><img src="https://wemeet-1302608036.cos.ap-shanghai.myqcloud.com/WeMeetStatic/image/WeMeetMiniLogo.png" class="logo" alt=""></div>
        <div class="btn" @click.stop="confirmDownLoad">{{leftBtnWord}} 
          <!-- <van-loading color="#1989fa" v-if="loading" />  -->
        </div>
      </div>
    </van-overlay>

  </div>
</template>
<script>
import QRCode from 'qrcode'
import { generateVcfFile, getPosterImgToAi } from '@/api/common'
export default {
  name: 'MainPageBtn',
  props: {
    customClass: {
      type: String,
      default: 'mx-12',
    },
    vcardParams: {
      type: Object,
      default: {},
    },
    userBaseInfo: {
      type: Object,
      default: {},
    },
    leftBtnWord: {
      type: String,
      default: 'Download QR code',
    },
    rightBtnWord: {
      type: String,
      default: 'Save the Business Card',
    },
    successTip: {
      type: String,
      default: '',
    },
    qrCodeUrl: {
      type: String,
      default: '',
    },
  },
  components: {},
  data() {
    return {
      show: false,
      loading: false,
    }
  },
  methods: {
    // initQRCode() {
    //   QRCode.toDataURL(this.vcardParams.vcard)
    //     .then((url) => {
    //       // 获取到url后即可在页面使用--二维码图片
    //       this.qrCodeUrl = url
    //       this.show = true
    //     })
    //     .catch((e) => {
    //       console.log('e', e)
    //     })
    // },
    confirmDownLoad() {
      if (this.loading) {
        return false
      }
      let host = process.env.NODE_ENV == 'production' ? 'https://wemeet-h5.wemeet.com/#/' : 'https://wemeet-h5-dev.wemeet.com/#/'
      let url = `${host}qrCodeByIconByName?logo=https://wemeet-1302608036.cos.ap-shanghai.myqcloud.com/WeMeetStatic/image/WeMeetMiniLogo.png&qrCodeUrl=${this.qrCodeUrl}&name=${this.userBaseInfo.name}&company=${this.userBaseInfo.companyName}`
      var headerClientInfo = { language: 'CN', eventKey: 'WeMeet', appKey: `WX_MINI_WEMEET` }
      this.headersNormal = {
        'x-call-client-info': JSON.stringify(headerClientInfo),
      }
      this.loading = true
      this.$toast.loading();
      getPosterImgToAi(this.headersNormal, { url, selector:'.box' }).then((res) => {
        console.log(res)
        const downloadLink = document.createElement('a')
        downloadLink.href = res.data
        downloadLink.download = `qrcode.png` // 设置下载文件的名称
        downloadLink.style.display = 'none' // 隐藏下载链接

        document.body.appendChild(downloadLink)
        downloadLink.click()
        document.body.removeChild(downloadLink)
        this.$toast(this.successTip)
        this.show = false
        this.loading = false
      }).catch(err=>{
        this.$toast.fail("请检查网络后重试")
      })
    },
    downLoadQrcode() {
      this.show = true
      // this.initQRCode()
    },
    downLoadvcf() {
      // Response.AppendHeader("Content-Disposition", "filename=" + 'contact.vcf');      
      if (this.vcardParams.vcardFileUrl) {
        const downloadLink = document.createElement('a')
        downloadLink.download = 'contact.vcf' // 设置下载文件的名称

        downloadLink.href = this.vcardParams.vcardFileUrl
        downloadLink.click()
      } else {
        const downloadLink = document.createElement('a')
        downloadLink.href = 'data:text/x-vcard;charset=utf-8,' + encodeURIComponent(this.vcardParams.vcard)
        downloadLink.download = 'contact.vcf'
        downloadLink.click()
      }
      // console.log(this.vcardParams.vcard)
    },
  },
  mounted() {},
}
</script>



<style lang="less" scoped>
.dialogContainer {
  width: 300px;
  height: 400px;
  background: #ffffff;
  border-radius: 10px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  padding: 24px;
  box-sizing: border-box;
  .close {
    width: 25px;
    height: 25px;
    background: #f5f5f5;
    position: absolute;
    top: 12px;
    right: 12px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .name {
    font-size: 19px;
    color: #262626;
    font-weight: bold;
    margin-top: 5px;
  }
  .position {
    color: #8c8c8c;
    font-size: 15px;
    margin-top: 5px;
  }
  .qrCode {
    width: 160px;
    height: 160px;
    margin-top: 10px;
  }
  .logo {
    width: 80px;
    height: 19px;
    margin-top: 5px;
  }
  .btn {
    width: 250px;
    height: 44px;
    border-radius: 6px;
    border: 1px solid #cccccc;
    text-align: center;
    line-height: 44px;
    color: #666;
    font-size: 15px;
    margin-top: 25px;
  }
}
</style>
